/**
 * Slot capacity lookup shared by the appointment dialogs (BookDialog,
 * RebookDialog, BulkRebookDialog, ConfirmAppointmentDialog). Extracted
 * 2026-11-01 (Batch 7 Wave 3) from four verbatim copies — behavior-identical:
 * prefer the Phase 2 per-key `slots` map from the /appointments/capacity
 * endpoint; fall back to the legacy top-level Morning/Evening fields when
 * the map is absent.
 *
 * The settings-module BlockRescheduleDialog keeps its own local copy by
 * design: its return shape is `{ booked, max }` (drops `pending`) and it
 * renders inside a Radix <Select>, not the slot-button grid — unifying would
 * change its behavior/UI contract.
 */

/** Per-key booked/pending/max counters for one date's slot. */
export interface SlotCapacity {
  booked: number;
  pending: number;
  max: number;
}

/**
 * Capacity for one slot key. `capacity` is the raw useSlotCapacity() payload:
 * either `{ slots?: Record<string, SlotCapacity> }` (Phase 2 per-key map) or
 * the legacy `{ Morning?: SlotCapacity; Evening?: SlotCapacity }` fields.
 * Returns undefined when neither shape carries the key.
 */
export function capFor(
  capacity: unknown,
  key: string,
): SlotCapacity | undefined {
  const fromMap = (capacity as { slots?: Record<string, SlotCapacity> } | undefined)?.slots?.[key];
  if (fromMap) return fromMap;
  if (key === "Morning") return (capacity as { Morning?: SlotCapacity } | undefined)?.Morning;
  if (key === "Evening") return (capacity as { Evening?: SlotCapacity } | undefined)?.Evening;
  return undefined;
}